import { isDatastartImageProvider } from '../constants/datastartImageModels.js';

// 本站圈选历史使用不透明黑白蒙版（白=编辑），DataStart 使用 Alpha=0 表示编辑。
// 原生 Alpha 蒙版已经符合接口语义，必须原样保留；转换只发生在提交副本中。
export const toDatastartAlphaMaskPixels = (pixels) => {
  if (!pixels?.length || pixels.length % 4 !== 0) throw new Error('DataStart 蒙版像素无效，请重新圈选区域');
  for (let offset = 3; offset < pixels.length; offset += 4) {
    if (pixels[offset] < 255) return null;
  }
  const converted = new Uint8ClampedArray(pixels);
  let hasSelectedPixels = false;
  for (let offset = 0; offset < converted.length; offset += 4) {
    const value = pixels[offset];
    if (value !== pixels[offset + 1] || value !== pixels[offset + 2]) {
      throw new Error('DataStart 蒙版需为透明区域选区或本站黑白蒙版，请重新圈选区域');
    }
    const selected = value >= 128;
    converted[offset + 3] = selected ? 0 : 255;
    hasSelectedPixels ||= selected;
  }
  if (!hasSelectedPixels) throw new Error('DataStart 蒙版没有选中编辑区域，请先圈选区域');
  return converted;
};

export const toDatastartAlphaMask = async (source) => {
  if (typeof source !== 'string' || !source.trim()) throw new Error('DataStart 蒙版无效，请重新圈选区域');
  const mask = await new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('DataStart 蒙版读取失败，请重新圈选区域'));
    image.src = source;
  });
  const canvas = document.createElement('canvas');
  canvas.width = mask.naturalWidth || mask.width;
  canvas.height = mask.naturalHeight || mask.height;
  const context = canvas.getContext('2d');
  if (!context || !canvas.width || !canvas.height) throw new Error('DataStart 蒙版无法读取，请重新圈选区域');
  try {
    context.drawImage(mask, 0, 0);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const converted = toDatastartAlphaMaskPixels(imageData.data);
    if (!converted) return source;
    imageData.data.set(converted);
    context.putImageData(imageData, 0, 0);
    return canvas.toDataURL('image/png');
  } catch (error) {
    if (error?.name === 'SecurityError') throw new Error('DataStart 蒙版无法跨域读取，请重新圈选区域');
    throw error;
  }
};

export const prepareDatastartMaskPayload = async (payload, provider) => {
  if (!isDatastartImageProvider(provider) || !payload) return payload;
  const field = payload.maskImage ? 'maskImage' : payload.mask ? 'mask' : null;
  if (!field) return payload;
  return { ...payload, [field]: await toDatastartAlphaMask(payload[field]) };
};
